/**
 * FILE: apps/hub/src/hooks/useActor.ts
 * PURPOSE: Custom React hook.
 * AGENT_CONTEXT: Reusable logic. Follow Rules of Hooks. No side effects in render.
 * LAST_REVIEWED: 2026-05-07
 */

import type { ActivityActor } from '@fintree/supabase/shared'
import { useAuth } from '@/hooks/useAuth'

/** Returns the ActivityActor for the current authenticated staff member. */
export function useActor(): ActivityActor {
  const { identity } = useAuth()
  if (!identity) throw new Error('useActor called without an authenticated identity')
  return {
    userId: identity.staffId,
    userName: identity.name,
    userRole: identity.roleName,
  }
}
